import { render, staticRenderFns } from "./TopSectionTitle.vue?vue&type=template&id=498dd580&scoped=true"
import script from "./TopSectionTitle.vue?vue&type=script&lang=js"
export * from "./TopSectionTitle.vue?vue&type=script&lang=js"
import style0 from "./TopSectionTitle.vue?vue&type=style&index=0&id=498dd580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498dd580",
  null
  
)

export default component.exports